import { render, staticRenderFns } from "./TwoColumnFeaturesEditor.vue?vue&type=template&id=0547c3c8"
import script from "./TwoColumnFeaturesEditor.vue?vue&type=script&lang=js"
export * from "./TwoColumnFeaturesEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports